export enum EnumCompensation {
    International = 0,
    National = 1,
    All = 2
}